import React from 'react';
import InfiniteScrollCards from '@/components/cards/InfiniteScrollCards';
import NotificationCardItems from './NotificationCardItems';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const NotificationCards = ({
  category,
  code,
  event,
  itemsPerRow,
}) => {
  const state = Selectors.useNotificationCards({ category, code, event });
  const fetchData = Events.useFetchNotifications(category, { code });

  const handleScroll = () => {
    const page = state.currentPage + 1;
    if (page <= state.pageCount) {
      fetchData({
        event, page, pageSize: state.pageSize, append: true,
      });
    }
  };

  return (
    <InfiniteScrollCards
      className="aridhia-notification-cards"
      entity="notification"
      handleScroll={handleScroll}
      icon="user"
      items={state.notifications}
      itemsPerRow={itemsPerRow}
      loading
      readErrors={state.readErrors}
      readStatus={[state.readStatus]}
    >
      <NotificationCardItems category={category} code={code} event={event} items={state.notifications} />
    </InfiniteScrollCards>
  );
};

export default NotificationCards;
